import { PALETTE } from '../common/styles/palette';
const drawerWidth = 230;
const headerAndFooterH = 150;
export const layoutStyle : any = (theme: any) => {
    return {

        toolBar: {
            minHeight: '45px',
            flexDirection: 'column' as 'column',
            alignItems: 'unset',
            padding: 0
        },
        toolBarHeader: {
            display: 'flex',
            padding: '0px 16px',
            alignItems: 'center'
        },
        toolbarBreadCrumb: {
            padding: '0px 16px'
        },
        appBar: {
            transition: theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            backgroundColor: PALETTE.AppBarBackgroundColor
        },
        appBarShift: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
            transition: theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        hide: {
            display: 'none',
        },
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
        },
        drawerPaper: {
            backgroundColor: 'transparent',
            position: 'relative' as 'relative',
            width: drawerWidth,
            [theme.breakpoints.only('xs')]: {
                width: '100vw',
            },
        },
        drawerRoot: {
            // top: '98px !important',
            top: '100px !important',
            height: `calc(100vh - ${headerAndFooterH}px)`,
            [theme.breakpoints.only('xs')]: {
                width: '100vw',
            },
        },
        drawerBody: {
            display: 'flex',
            flexDirection: 'column' as 'column',
            flexGrow: 1,
            backgroundColor: PALETTE.Drawer.Body.BackgroundColor,
            color: PALETTE.Drawer.Body.FontColor,
            paddingLeft: 10,
            paddingRight: 10,
            paddingTop: 20,

        },
        // appBarSpacer: theme.mixins.toolbar,
        drawerHeader: {
            display: 'flex',
            alignItems: 'center',
            //padding: '0 8px',
            height: '45px !important',
            minHeight: '45px !important',
            justifyContent: 'flex-end',
            backgroundColor: PALETTE.Drawer.Header.BackgroundColor
        },
        main: {
            height: '100%',
            maxHeight: `calc(100vh - ${headerAndFooterH}px)`,
            overflow: 'auto',
            maxWidth: '100vw',
            flexGrow: 1,
            // padding: theme.spacing(0),
            padding: 15,
            [theme.breakpoints.only('xs')]: {
                padding: 10,
            },
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            // marginLeft: -drawerWidth,
        },
        contentShift: {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        },
        routerLink: {
            textDecoration: 'none',
            borderBottom: '1px solid #FFF'
        },
        layoutRoot: {
            height: '100%',
            paddingTop: 100
        },
        layoutContent: {
            padding: 10,
            height: '100%'
        },
        footer: {
            position: 'absolute' as 'absolute',
            left: 0,
            bottom: 0,
            right: 0,
            backgroundColor: PALETTE.Primary,
            // height: 48
        },
        footerRow: {
            height: '100%',
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between'
        },
        footerItem: {
            height: '100%',
            alignItems: 'center',
            display: 'flex',
        },
        footerIcon: {
            color: '#FFF',
            height: 25,
            width: 25,

            margin: 'auto 20px',
            [theme.breakpoints.down('xs')]: {
                margin: 'auto 8px',
            },
        },
        iconSminchia: {
            height: 30,
            width: 49,
            marginTop: "10px",
        },
        flexEnd: {
            justifyContent: 'flex-end'
        },
        newMessageReceivedContainer: {
            display: "flex",
            justifyContent: 'flex-end',
        },
        newMessageReceivedButton: {
            backgroundColor: 'yellow',
            padding: "2px",
            color: "#333",
            margin: "0px",
        },
        userStatsContainer: {
            alignItems: "center",
            display: "flex",
        },
        userStatContainer: {
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
        },
        userStatNumer: {
            color: PALETTE.Primary,
            background: "#FFF",
            display: "flex",
            justifyContent: "center",
            margin: "5px",
            fontWeight: "bold",
            borderRadius: "10px",
            /* width: 50px; */
            minWidth: "70px",
        }
    }
}